"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSubscribeLinkClick = void 0;
var cookies_1 = require("../../shared/cookies");
var config_1 = require("../../shared/config");
function handleSubscribeLinkClick(e, $link) {
    e.preventDefault();
    var config = (0, config_1.getHovoThemeConfig)();
    var id = $link.data("course-id");
    (0, cookies_1.setCookie)("course-id", id);
    var waitinglist = $link.data("waitinglist");
    var url = waitinglist ? config.waitinglistPage : config.payPage;
    location.href = url;
}
exports.handleSubscribeLinkClick = handleSubscribeLinkClick;
